import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { GridBackground } from "@/components/ui/grid-background";
import { SlapLogo } from "@/components/ui/slap-logo";
import { organizationsQueryOptions } from "@/lib/queries";

export const Route = createFileRoute("/onboarding")({
	loader: async ({ context: { queryClient }, location }) => {
		// Allow invite-team page even with organizations
		if (location.pathname === "/onboarding/invite-team") {
			return;
		}

		const organizations = await queryClient.ensureQueryData(
			organizationsQueryOptions(),
		);

		// If user has organizations, redirect to home
		if (organizations.length > 0) {
			throw redirect({ to: "/" });
		}
	},
	component: OnboardingLayout,
});

function OnboardingLayout() {
	return (
		<>
			<GridBackground />

			{/* Content */}
			<div className="relative flex h-screen w-full flex-col items-center overflow-y-auto scrollbar-premium">
				<div className="shrink-0 pt-10 text-primary">
					<SlapLogo width={100} animate={false} />
				</div>

				<div className="w-full px-4 py-16">
					<Outlet />
				</div>
			</div>
		</>
	);
}
